import { ajax } from "@utils";

export const deliveryPackageService = {
  /**
   * 新增貨運包裹資訊
   * @key CreateConstructionDeliveryPackageByProperty
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} info - 包裹資訊
   *
   * @returns
   */
  create: (constructionUuid, info) => {
    return ajax
      .post(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/delivery-packages`,
        {
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            ...info
          })
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res;
      });
  },
  /**
   * 取得貨運包裹列表
   * @key SearchConstructionDeliveryPackageByProperty
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} condition - 查詢條件
   * @returns
   */
  getAll: (constructionUuid, condition) => {
    return ajax
      .get(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/delivery-packages`,
        {
          params: {
            ...condition
          }
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.data;
      });
  },
  /**
   * 取得貨運包裹資訊
   * @key GetConstructionDeliveryPackageByProperty
   * @param {number} id - 貨運包裹 id
   * @returns
   */
  get: id => {
    return ajax
      .get(`${process.env.REACT_APP_API_URL}/property/construction-delivery-packages/${id}`)
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }

        return res.data;
      });
  },
  /**
   * 更新貨運包裹資訊
   * @key UpdateConstructionDeliveryPackageByProperty
   * @param {number} id - 貨運包裹 id
   * @param {object} info - 貨運包裹資訊
   * @returns
   */
  update: (id, info) => {
    return ajax
      .put(`${process.env.REACT_APP_API_URL}/property/construction-delivery-packages/${id}`, {
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          ...info
        })
      })
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  },
  /**
   * 刪除貨運包裹
   * @key DeleteConstructionDeliveryPackageByProperty
   * @param {number} id - 包裹 id
   * @returns
   */
  delete: id => {
    return ajax
      .delete(`${process.env.REACT_APP_API_URL}/property/construction-delivery-packages/${id}`)
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  },
  /**
   * 取消待退貨包裹
   * @key CancelConstructionDeliveryPackageWaitReturnByProperty
   * @param {string} constructionUuid - 建案 uuid
   * @param {number} id - 包裹 id
   * @returns
   */
  cancelWaitReturn: (constructionUuid, id) => {
    return ajax
      .put(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/delivery-packages/${id}/cancel-wait-return`
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  },
  /**
   * 領取貨運包裹
   * @key ChangeConstructionDeliveryPackageToCollectedByProperty
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} info - 包裹資訊
   * @returns
   */
  collect: (constructionUuid, info) => {
    return ajax
      .put(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/delivery-packages/collected`,
        {
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            ...info
          })
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res;
      });
  },
  /**
   * 待退貨貨運包裹登記
   * @key ChangeConstructionDeliveryPackageToWaitReturnByProperty
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} info - 包裹資訊
   * @returns
   */
  return: (constructionUuid, info) => {
    return ajax
      .put(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/delivery-packages/wait_return`,
        {
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            ...info
          })
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res;
      });
  },
  /**
   * 退貨貨運包裹完成
   * @key ChangeConstructionDeliveryPackageToReturnedByProperty
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} info - 包裹資訊
   * @returns
   */
  returned: (constructionUuid, info) => {
    return ajax
      .put(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/delivery-packages/returned`,
        {
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            ...info
          })
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res;
      });
  }
};
